import {
  getScorecardDefaultCode,
  isScorecardDefaultCode,
  type ScorecardCodeLanguage,
} from "../../../criterionConfig";
import { CODE_CHECK_LANGUAGES } from "../EditCriterionView.constants";

import CodeEditor from "@/components/CodeEditor";
import type { LanguageType } from "@/components/CodeEditor/types";
import { useCodeMonacoCompletion } from "@/components/PowerBlock/Blocks/categories/data-sources/CodeBlock/hooks";

interface ScorecardCodeEditorFieldProps {
  code: string;
  codeLanguage: ScorecardCodeLanguage;
  sourceTitles: string[];
  onCodeChange: (code: string) => void;
  onLanguageChange: (language: ScorecardCodeLanguage) => void;
}

export const ScorecardCodeEditorField = ({
  code,
  codeLanguage,
  sourceTitles,
  onCodeChange,
  onLanguageChange,
}: ScorecardCodeEditorFieldProps) => {
  useCodeMonacoCompletion(codeLanguage, sourceTitles);

  const handleCodeLanguageChange = (language: LanguageType) => {
    if (language === "PYTHON" || language === "JAVASCRIPT") {
      onLanguageChange(language);
      if (isScorecardDefaultCode(code)) {
        onCodeChange(getScorecardDefaultCode(language));
      }
    }
  };

  return (
    <CodeEditor
      code={code}
      selectedLanguage={codeLanguage}
      languages={CODE_CHECK_LANGUAGES}
      controlsType="dropdown"
      languageSelectorLabel="Language"
      showRuntimeDetails={false}
      height="320px"
      className="border-border/70"
      handleCodeChange={onCodeChange}
      handleLanguageChange={handleCodeLanguageChange}
    />
  );
};
